module.exports = __webpack_public_path__ + "img/Competitionleft2.44171d07.png";